/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import moment, { Moment } from 'moment';
import { Observable, of, ReplaySubject, Subject, Subscription } from 'rxjs';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { MapsService } from 'app/modules/maps/maps.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { HotToastService } from '@ngneat/hot-toast';
import { PickerOptions, PickerSelectDisableOptions, PickerSelectOptions } from '../data-picker/data-picker.interface';
import { DataPickerService } from 'app/core/services/data_picker/data_picker.service';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { RouteFormOptions } from '../route-form/route-form.types';
import { catchError, debounceTime, distinctUntilChanged, filter, map, startWith, switchMap, take, takeUntil } from 'rxjs/operators';
import _, { includes } from 'lodash';
import { NewJobService } from '../new-job/new-job.service';
import { MatDialogRef } from '@angular/material/dialog';
import { PreviewAddressFormComponent } from '../preview-address-form/preview-address-form.component';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import { CreateRouteService } from './create-route.service';
import RRule from 'rrule';
import { CreatedPopupComponent, PopupContent } from '../created-popup/created-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { RecurringRouteService } from '../recurring-route-details/recurring-route.service';
import dayjs from 'dayjs';
@Component({
  selector: 'app-create-route-form',
  templateUrl: './create-route-form.component.html',
  styleUrls: ['./create-route-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CreateRouteFormComponent implements OnInit, OnDestroy, OnChanges {

  @ViewChild('start_location') start_location: ElementRef;
  @ViewChild('end_location') end_location: ElementRef;
  @ViewChild('createRouteFormEleRef') createRouteFormEleRef!: ElementRef;

  @Input() options: RouteFormOptions;
  @Input() date: any;
  @Input() data?: any;
  @Input() isMasterRouteEdit?: boolean = false;
  @Input() openPicker: boolean;
  @Input() drawerName: string = 'routeForm';
  @Input() showRouteAlert?: boolean = false;
  @Input() timezone?: string = this.utilityService.timeZone;
  @Input() parentModule?: string;
  @Output() actionComplete: EventEmitter<any> = new EventEmitter();

  enableCalculateDistanceApi: boolean = true;
  recurringRouteFormErrorMessages: { [key: string]: string } = {};
  module: string = 'JOB';
  selectedRouteColor = '#e67e22';
  selectedRouteTextColor = '#FFFFFF';
  totalRouteInstance: number = 0;
  minimumRouteInstanceEndValue: number = 1;
  totalJobsDurationMileSec: number = 0;
  totalRouteDuration: string = '0';
  totalJobDuration: any = null;
  companyConfig: any;
  showMeridian: boolean;
  isMoveable: boolean[] = [];
  showDetailedRouteCreationForm: boolean = false;
  // Form
  createRouteForm: FormGroup;
  jobPickerOptions: PickerOptions = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('route.add.job')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    selectOption: PickerSelectOptions.multiSelect,
    selectionDisableBasedOn: PickerSelectDisableOptions.GEOLOCATION,
    customParams: {},
    filters: { dateRange: { enabled: true, hideCloseIcon: false }, enableCategory: true, enableAssignmentStatus: true, enableAssignEmployee: true },
    dataConfig:null
  };
  openJob: boolean = false;
  jobs: any[] = [];
  jobPickerSubscription: Subscription;
  timezoneDisplayName: string = '';

  today: any = moment().toDate();
  recurrenceStartMin: any = moment().toDate();
  routeStartMin: any = moment().toDate();
  //Address
  employeeFetching: boolean = false;
  employeeParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_assigned_to_team': true,
    'populate_teams': true,
    'filter.is_active': true
  };
  employeePagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  employeeValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  employeeOptions: any[] = [];
  employees: Observable<any[]> = new Observable<any[]>();
  startLocationGeoCords: any[];
  currentServiceAddress: any = {
    street: '',
    landmark: '',
    city: '',
    state: '',
    country: {
      value: '',
      label: '',
    },
    zipcode: '',
    latitude: 0,
    longitude: 0,
  };

  days: Array<any> = [
    {
      week: [
      { label: 'Monday', value: false ,key:'MO'},
      { label: 'Tuesday', value: false,key:'TU' },
      { label: 'Wednesday', value: false,key:'WE' },
      { label: 'Thursday', value: false,key:'TH' },
      { label: 'Friday', value: false,key:'FR' },
      { label: 'Saturday', value: false,key:'SA' },
      { label: 'Sunday', value: false,key:'SU' },
    ]
    }
  ];

  rRuleOptions: any;
  cancelErrorHandling$: Subject<void> = new Subject<void>();


  // map
  activeGeoCords: number[] = [];
  map: any;

  distanceCalculated: any = {
    leg_details:[],
    distance:0,
    time:0
  };
  isGettingDistanceData: boolean = false;
  isInstanceEdit: boolean = false;
  rRuleText: string = '';
  departureDateTime: string = `${moment(this.today).format(this.utilityService?.dateFormat)} ${moment(this.today).format(this.utilityService?.timeFormat)}`;
  departureDateTimeDuration: string = '';

  private unsubscribe$ = new Subject<void>();

  constructor(
    private _localStorageService: LocalStorageService,
    private _mapService: MapsService,
    private _dataCollectorService: DataCollectorService,
    private _toast: HotToastService,
    private _zuperDrawerService: ZuperDrawerService,
    private _datapickerService: DataPickerService,
    public utilityService: UtilityService,
    private newJobService: NewJobService,
    private zuperDialogService: ZuperDialogService,
    private form_builder: FormBuilder,
    private createRouteService: CreateRouteService,
    private translateService: TranslateService,
    private recurringRouteService: RecurringRouteService,
  ) {
  }

  drawerOpenedChanged(event: any): void {
    if (!event) {
      this.openJob = false;
      if (this.jobPickerSubscription?.unsubscribe) {
        this.jobPickerSubscription?.unsubscribe();
      }
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
     this.resetValues();
     this.cancelErrorHandling$.next();
    this.cancelErrorHandling$.complete();
    }else {
      const currentTime = moment.tz(moment(),this.timezone);
      this.today = this.utilityService.getNextQuarterHour(currentTime.clone(),true).toDate();
      this.recurrenceStartMin = !this.utilityService.companyConfig?.jobs?.['departure_in_past'] ? this.utilityService.getNextQuarterHour(currentTime.clone(), false).toDate() : null;
      this.routeStartMin = this.utilityService.getNextQuarterHour(currentTime.clone(),false).toDate();
      this.initFormBuilder();
      if (this.options?.state === 'new') {
        const currentTime = moment.tz(moment(), this.timezone);
        this.createRouteForm?.get('date_time').setValue(this.utilityService.getNextQuarterHour(currentTime.clone(), true).toDate());
      } else if (this.options?.state === 'clone') {
        const departureDate = moment(this.data?.departure).tz(this.timezone);
        const currentTime = moment.tz(moment(), this.timezone);
        const dateToSet = departureDate.isBefore(currentTime) ? currentTime : departureDate;
        this.createRouteForm?.get('date_time').setValue(dateToSet);
      } else if (this.options?.state === 'edit') {
        if (this.isMasterRouteEdit && this.data?.route_start) {
          this.createRouteForm?.get('date_time').setValue(this.data?.route_start);
        } else if (!this.isMasterRouteEdit && this.data?.departure) {
          this.createRouteForm?.get('date_time').setValue(this.data?.departure);
        } else {
          const currentTime = moment.tz(moment(), this.timezone);
          this.createRouteForm?.get('date_time').setValue(this.utilityService.getNextQuarterHour(currentTime.clone(), true).toDate());
        }
      }
      this.setRouteCreationFormScroll();
    }
  }

  resetValues(): void{
    this.createRouteForm.reset();
    this.createRouteForm = null;
    this.jobs = [];
    this.selectedRouteColor = '#e67e22';
    this.selectedRouteTextColor = '#FFFFFF';
    this.distanceCalculated = { leg_details:[],distance:0,time:0};
    this.createRouteFormControls?.repeat?.get('type').setValue('WEEKS');
    this.days = [
      {
        week: [
        { label: 'Monday', value: false ,key:'MO'},
        { label: 'Tuesday', value: false,key:'TU' },
        { label: 'Wednesday', value: false,key:'WE' },
        { label: 'Thursday', value: false,key:'TH' },
        { label: 'Friday', value: false,key:'FR' },
        { label: 'Saturday', value: false,key:'SA' },
        { label: 'Sunday', value: false,key:'SU' },
      ]
      }
    ];
  }

  setRouteCreationFormScroll(delay: number = 0): void {
    if (this.createRouteFormEleRef) {
      this.createRouteFormEleRef.nativeElement.scrollTop = 0;
    }
  }

  toggleJob(): void {
    this.jobPickerOptions.customParams = {};
    if(this.createRouteFormControls?.recurrence.value === '' || (this.options.state !== 'new' && !this.isMasterRouteEdit)){
      this.jobPickerOptions.dataConfig = { routeJobFromRouteWarning: true, routeUid: this.data?.route_uid };
      this.jobPickerOptions.customParams = { ...this.jobPickerOptions.customParams, 'filter.is_recurrence': false };
      this.jobPickerOptions.filters = {...this.jobPickerOptions.filters,showRecurrenceMaster:true,dateRange:{
        enabled: true, hideCloseIcon: false
      }, enableCategory: true, enableAssignmentStatus: true, enableAssignEmployee: true};
      this.module = 'JOB';
    }else{
      const routeDates = this.createRouteFormControls?.departure_dates?.value;
      const futureDates = routeDates?.filter((date: any) => moment.utc(date).tz(this.timezone).isSameOrAfter(moment.tz(moment(),this.timezone), 'date'));
      const routeStartDate = moment(futureDates[0]).format('YYYY-MM-DD');
      const routeEndDate = moment(futureDates[futureDates.length - 1]).format('YYYY-MM-DD');
      const routeCount = futureDates?.length;
      const rRule = this.rRuleOptions?.toString().replace(':', '=').replace('\n', ';').replace('RRULE:','');

      const rRuleFrequency = RRule.FREQUENCIES[this.createRouteForm.value.RRule.options.freq];
      this.jobPickerOptions.filters = { ...this.jobPickerOptions.filters, showRecurrenceMaster: true, enableAssignmentStatus: false, enableShowAllJobs: true, enableAssignEmployee: false };
      this.jobPickerOptions = {
        ...this.jobPickerOptions, dataConfig: { ...this.createRouteForm.value, timeZone: this.timezone, jobs: this.jobs, associateJobAfterCreation: this.options.state === 'edit' ? true : false, isCustomRoute: this.createRouteForm.value?.recurrence === 'CUSTOM'},
        customParams: {
          ...this.jobPickerOptions.customParams, 'filter.frequency': rRuleFrequency, 'filter.eligible_jobs': true, 'filter.has_route': false,
          'filter.route_count': routeCount, 'filter.route_start_date': routeStartDate, 'filter.route_end_date': routeEndDate,
          'filter.recurring_route_rule': rRule
        }
      };
      if (this.options.state === 'new') {
        if (this.createRouteForm.value?.recurrence === 'CUSTOM') {
          this.jobPickerOptions.customParams = { ...this.jobPickerOptions.customParams,'filter.route_is_created_through_custom': true };
        }
      }
      if (this.options.state === 'edit') {
        this.jobPickerOptions.customParams = { ...this.jobPickerOptions.customParams, 'filter.recurring_route_uid': this.data?.recurring_route_uid };
      }
      this.module = 'RECURRENCE_JOB_MASTER';
    }

    this.openJob = true;

    this.jobPickerSubscription = this._datapickerService.onInit.subscribe(
      (res: any) => {
        this.jobs = res;
        this.jobs.forEach(() => this.isMoveable.push(false));
        this.jobs.map((jobItem) => {
          jobItem.customerName = this.utilityService.concatTwoStrings(jobItem.customer?.customer_first_name, jobItem?.customer?.customer_last_name) ||
            jobItem?.organization?.organization_name || jobItem?.property?.property_name || '';
            jobItem.customerAddress = this.createRouteService.getAddressText(jobItem?.customer_address) || this.createRouteService.getAddressText(jobItem?.organization?.organization_address) || this.createRouteService.getAddressText(jobItem?.property?.property_address) || '';
            jobItem.customerIcon = this.getCustomerIcon(jobItem);
            jobItem.isNewJobAdded = true;
          });
        this.openJob = false;
        this.createRouteForm.markAsDirty();
        if (this.jobs.length > 0) {
          this.calculateRouteDistances();
          this.emitChangesInMap();
        }
      }
    );
  }

  getCustomerIcon(routeJobDetails: any): any {
    let iconText: string = 'ti-user';
    if (routeJobDetails.customer?.customer_first_name) {
      iconText = 'ti-user';
    }
    else if (routeJobDetails.organization?.organization_name) {
      iconText = 'ti-building';
    }
    else if (routeJobDetails.property?.property_address) {
      iconText = 'ti-building-estate';
    }
    return iconText;
  }

  getPickerFilter(): any {
    return [...this.jobs];
  }

  dataPickerEventHandler(event: any): void {
    if (event.drawerClosed) {
      this.openJob = false;
      if (this.jobPickerSubscription?.unsubscribe) {
        this.jobPickerSubscription.unsubscribe();
      }
    }
  }

  closeDrawer(isComplete: boolean = false): void {
    this.openPicker = false;
    this.showDetailedRouteCreationForm = false;
    if (this.openPicker) {
      this._zuperDrawerService.getComponent(this.drawerName).open();
    } else {
      this._zuperDrawerService.getComponent(this.drawerName).close();
    }
    this.actionComplete.emit({
      state: this.options?.state,
      completed: isComplete,
      isRecurringRoute: true,
    });
  }

  getAddressFormGroup(type: string): FormGroup {
    return new FormGroup({
      'street': new FormControl('', type === 'start' ? Validators.required : null),
      'landmark': new FormControl(''),
      'city': new FormControl('', type === 'start' ? Validators.required : null),
      'state': new FormControl(''),
      'latitude': new FormControl(''),
      'longitude': new FormControl(''),
      'country': new FormControl(''),
      'zipcode': new FormControl('')
    }, type === 'start' ? Validators.required : null);
  }

  ngOnDestroy(): void {
    if (this.jobPickerSubscription?.unsubscribe) {
      this.jobPickerSubscription.unsubscribe();
    }
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.cancelErrorHandling$.next();
    this.cancelErrorHandling$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('openPicker' in changes) {
      moment.tz.setDefault(this.timezone);
      this.openPicker = changes.openPicker.currentValue;
      if (this.openPicker) {
        this._zuperDrawerService.getComponent(this.drawerName).open();
        if (['rr_details','dispatch'].includes(this.parentModule) && this.timezone) {
          this.timezoneDisplayName = this.utilityService.getTimezoneDisplayName(this.timezone);
        }
      } else {
        const drawer = this._zuperDrawerService.getComponent(this.drawerName);
        if (drawer) {
          drawer.close();
        }
      }
    }
    if ('options' in changes) {
      this.options = changes.options.currentValue;
      this.setEditData();
    }
    if ('data' in changes) {
        this.setEditData();
    }
  }

  setEditData(): void{
    if (!this.createRouteForm?.value) {
      return;
    }
    if(this?.options?.state !== 'new' && this.isMasterRouteEdit === false){
      this.isInstanceEdit = true;
    }
    if (this.data !== null && this.data !== undefined) {
      this.showDetailedRouteCreationForm = true;
    if (this.data?.jobs?.length > 0 && this.isMasterRouteEdit === false) {
      const jobData = _.cloneDeep(this.data?.jobs);
      jobData.map((item: any)=>{
          // eslint-disable-next-line guard-for-in
          for (const key in item?.job) {
            item[key] = item.job[key];
          }
          item.customerName = this.utilityService.concatTwoStrings(item.customer?.customer_first_name, item?.customer?.customer_last_name) ||
          item?.organization?.organization_name || item?.property?.property_name || '';
          item.customerAddress = this.createRouteService.getAddressText(item?.customer_address) || this.createRouteService.getAddressText(item?.organization?.organization_address) || this.createRouteService.getAddressText(item?.property?.property_address) || '';
          item.customerIcon = this.getCustomerIcon(item);
          return item;
        });
        this.jobs = jobData;
      } else {
        this.jobs = [];
      }
      const patchData = {
        ...this.data,
        recurring_route_name: this.data?.route_name,
        route_description: this.data?.route_description || '',
        assigned_to: this.data?.assigned_to?.map((assigned: any) => {
          const data = {
            ...assigned,
            ...assigned.user, team: assigned.team
          };
          if (assigned?.user?.profile_picture) {
            data['hasValidProfilePicture'] = this.utilityService.hasValidProfilePicture(assigned?.user?.profile_picture);
          }
          return data;
        }),
        start_location_value: this.createRouteService.getAddressText(this.data?.start_location),
        duration: this.data?.duration,
        date_time: this.options?.state === 'clone' && moment(this.data?.departure).tz(this.timezone).isBefore(moment()) ? moment() : moment(this.data?.departure).tz(this.timezone),
        start_location: {
          ...this.data?.start_location,
          'latitude': this.data?.start_location?.geo_cords[0],
          'longitude': this.data?.start_location?.geo_cords[1],
          'city': this.data?.start_location?.city || this.data?.start_location?.name || '',
          'zipcode': this.data?.start_location?.zip_code || this.data?.start_location?.zipcode || '',
        }
      };
      if(this.data?.end_location?.geo_cords){
        patchData['end_location_value'] = this.createRouteService.getAddressText(this.data?.end_location);
        patchData['end_location'] = {
          ...this.data?.end_location,
          'latitude': this.data?.end_location?.geo_cords[0],
          'longitude': this.data?.end_location?.geo_cords[1],
          'city': this.data?.end_location?.city || this.data?.end_location?.name || '',
          'zipcode': this.data?.end_location?.zip_code || this.data?.end_location?.zipcode || '',
        };
      }
      this.createRouteForm.controls.recurrence_ends.get('ends_on').setValue(this.data?.route_end, { emitEvent: false });
      if(this.isMasterRouteEdit === true){
        patchData['recurring_route_name'] = this.data?.recurring_route_name;
        patchData['route_description'] = this.data?.recurring_route_description;
        patchData['duration'] = this.data?.route_duration;
        this.createRouteForm?.get('recurrence').setValue('CUSTOM',{emitEvent: false});
        this.createRouteFormControls?.repeat?.get('count')?.setValue(this.data?.duration?.value ?? 1);
        const recurrenceType = ['WEEKS','MONTHS'].includes(this.data?.duration?.type);
        this.createRouteFormControls?.repeat?.get('type')?.setValue(recurrenceType ? this.data?.duration?.type: 'WEEKS');
        this.minimumRouteInstanceEndValue = this.data?.total_routes === 0 ? 1 : this.data?.total_routes ;
        if(this.options?.state === 'edit'){
          const endsAfterControl = this.createRouteFormControls?.recurrence_ends?.get('ends_after')
          endsAfterControl.setValue(this.minimumRouteInstanceEndValue, { emitEvent: false });
          endsAfterControl.setValidators(Validators.min(this.minimumRouteInstanceEndValue));
          endsAfterControl.updateValueAndValidity({ emitEvent: false });
        }
        this.parseStringToRRule(this.data?.rrule);
        if(this.data?.recurring_jobs?.length > 0){
        const jobData = this.data?.recurring_jobs?.map((item)=>{
          // eslint-disable-next-line guard-for-in
          for (const key in item?.job || item?.recurring_job) {
            item[key] =  item.job ? item.job[key] : item.recurring_job[key];
          }
            item.customerName = this.utilityService.concatTwoStrings(item.customer?.customer_first_name, item?.customer?.customer_last_name) ||
            item?.organization?.organization_name || item?.property?.property_name || '';
            item.customerAddress = this.createRouteService.getAddressText(item?.customer_address) || this.createRouteService.getAddressText(item?.organization?.organization_address) || this.createRouteService.getAddressText(item?.property?.property_address) || '';
            item.customerIcon = this.getCustomerIcon(item);
            return item;
          });
          this.jobs = [...jobData];
        }else{
          this.jobs = [];
        }
      }else{
        const recurrenceType = ['WEEKS','MONTHS'].includes(this.data?.duration?.type);
        this.createRouteFormControls?.repeat?.get('type')?.setValue(recurrenceType ? this.data?.duration?.type: 'WEEKS',{emitEvent: false});
      }
      this.selectedRouteColor = this.data?.color?.hex ? '#' +this.data?.color?.hex : this.data?.color;
      this.selectedRouteTextColor = this.utilityService.getTextColorBasedOnBg(this.selectedRouteColor);
      this.createRouteForm?.patchValue(patchData,{emitEvent: false});
      this.departureDateTimeDuration = this.routeTimeString(this.createRouteForm?.get('date_time')?.value);
      const endsOnDateValue = this.createRouteFormControls?.recurrence_ends?.get('ends_on')?.value;
      this.routeStartMin = moment(endsOnDateValue).endOf('day').toDate();
      if (this.isMasterRouteEdit) {
        const dtstart = moment.tz(this.rRuleOptions?.origOptions?.dtstart, this.timezone);
        const currentTime = moment.tz(moment(), this.timezone);
        const isCloneAndPast = this.options?.state === 'clone' && dtstart.isBefore(currentTime);
        const departureInPast = this.utilityService.companyConfig?.jobs?.['departure_in_past'];
        this.createRouteForm?.get('date_time').setValue(isCloneAndPast ? moment() : dtstart);
        const durationControl = this.createRouteFormControls?.duration;
        durationControl.addValidators(Validators.min(this.data?.route_duration));
        durationControl.updateValueAndValidity({ emitEvent: false });

        this.recurrenceStartMin = isCloneAndPast
          ? (!departureInPast ? moment() : null)
          : dtstart;
      } else {
        this.recurrenceStartMin = !this.utilityService.companyConfig?.jobs?.['departure_in_past']
          ? moment()
          : null;
      }
      this.calculateRouteDistances();
      this.emitChangesInMap();
    }

  }

  parseStringToRRule(rRuleString: string): void {
    const options = RRule.parseString(rRuleString);
    options.tzid = this.timezone;
    this.rRuleOptions = new RRule(options);
    this.setDaysFromRRule(this.rRuleOptions.options);
  }


  setDaysFromRRule(option: any): void {
    const options = { ...option };
    const frequency = RRule?.FREQUENCIES[options.freq];
    const dayNames = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    let days: string[] = [];

    const getDayString = (day: any): string => {
      if (day.n === undefined) {
        return dayNames[day?.weekday ?? day];
      } else {
        return `${day.n === -1 ? 0 : day.n}${dayNames[day.weekday]}`;
      }
    };

    if (options.byweekday) {
      days = options.byweekday.map(getDayString);
    } else if (options.bynweekday) {
      days = options.bynweekday.map(day => `${day[1] === -1 ? 0 : day[1]}${dayNames[day[0]]}`);
    }

    days.forEach((dayKey: any) => {
      let weekIndex = parseInt(dayKey[0], 10) - 1;
      weekIndex = Number.isNaN(weekIndex) ? 0 : weekIndex;
      const dayCode = isNaN(dayKey[0]) ? dayKey : dayKey.substring(1);
      const day = this.days[weekIndex < 0 ? 4 : weekIndex]?.week?.find(d => d.key === dayCode);
      if (day) {
        day.value = true;
      }
    });

    const recurrenceControl = this.createRouteForm?.get('recurrence');

    if (frequency === 'YEARLY' && days.length === 0) {
      recurrenceControl.setValue('YEARLY');
    } else if (frequency === 'MONTHLY' && options?.bymonthday?.length === 1 && option?.interval === 1) {
      recurrenceControl.setValue('MONTHLY');
    } else if (frequency === 'MONTHLY' && options?.byweekday?.length === 1) {
      recurrenceControl.setValue('MONTHLY-ORDINAL-WEEK');
    } else if (frequency === 'WEEKLY' && options?.byweekday?.length === 1 && option?.interval === 1 && moment(options?.dtstart).day() === options?.byweekday[0] + 1) {
      recurrenceControl.setValue('WEEKLY');
    } else if (frequency === 'DAILY') {
      recurrenceControl.setValue('DAILY');
    }
  }

  getAllEmployees(): void {
    const url = `${this._dataCollectorService.baseurl()}/user/all`;
    const urlParams = this.utilityService.constructParam(this.employeeParamObj);
    this.employeeFetching = true;
    this._dataCollectorService.getData(url, urlParams).subscribe((response: any) => {
      this.employeeOptions = response.data.map((emp)=>{
        if (emp?.profile_picture) {
          emp['hasValidProfilePicture'] = this.utilityService.hasValidProfilePicture(emp?.profile_picture);
        }
        return emp;
      });
      this.employeePagination.loadingIndex = response.current_page;
      this.employeePagination.totalPage = response.total_pages;
      this.employees = this.createRouteFormControls?.assigned_to?.valueChanges?.pipe(
        startWith(''),
        map((value: any) => this.employeeOptions)
      );
    }, (error: any) => {
      this.employeeFetching = false;
    });
  }

  onEmployeeSearch(): void {
    this.employees = this.employeeValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getEmployees(term))
    );
  }

  onEmployeeClear(): void {
    this.employees = this.getEmployees('');
  }

  onEmployeeChange(): void {
    const assignedTo: any[] = this.createRouteFormControls?.assigned_to.value;
    if (assignedTo?.length) {
      assignedTo.forEach(async (userDetails: any) => {
        if (!userDetails?.work_hours) {
          const userUid = userDetails?.user_uid;
          const userWorkHours = await this.newJobService.getUserWorkHours(userUid);
          userDetails['work_hours'] = userWorkHours;
        }
        if (userDetails?.profile_picture) {
          userDetails['hasValidProfilePicture'] = this.utilityService.hasValidProfilePicture(userDetails?.profile_picture);
        }
      });
      this.createRouteFormControls?.assigned_to.setValue(assignedTo);
      this.createRouteFormControls?.assigned_to.markAsDirty();
      this.checkJobConflict();
    }
  }

  onEmployeeScrollToEnd(): void {
    if (this.employeePagination.loadingIndex < this.employeePagination.totalPage) {
      const url = `${this._dataCollectorService.baseurl()}/user/all`;
      this.employeePagination.loadingIndex++;
      this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
      this.employeeParamObj['page'] = this.employeePagination.loadingIndex;
      this.employeeFetching = true;
      const urlParams = this.utilityService.constructParam(this.employeeParamObj);
      this._dataCollectorService.getData(url, urlParams).subscribe(
        (response: any) => {
          this.employeeFetching = false;
          this.employeeOptions = this.employeeOptions.concat(response.data);
          this.employeeOptions = this.employeeOptions.map((emp)=>{
            if (emp?.profile_picture) {
              emp['hasValidProfilePicture'] = this.utilityService.hasValidProfilePicture(emp?.profile_picture);
            }
            return emp;
          });
          this.employees = this.createRouteFormControls?.assigned_to?.valueChanges?.pipe(
            startWith(''),
            map((value: any) => this.employeeOptions)
          );
        }, (error: any) => {
          this.employeeFetching = false;
        });
    }
  }

  getEmployees(input: string): Observable<any[]> {
    this.employeePagination.keyword = input ? input : '';
    const url = `${this._dataCollectorService.baseurl()}/user/all`;
    this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
    this.employeeParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.employeeParamObj);
    this.employeeFetching = true;
    return this._dataCollectorService.getData(url, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response: any) => {
          this.employeePagination.loadingIndex = response.current_page;
          this.employeePagination.totalPage = response.total_pages;
          this.employeeOptions = response.data.map((emp)=>{
            if (emp?.profile_picture) {
              emp['hasValidProfilePicture'] = this.utilityService.hasValidProfilePicture(emp?.profile_picture);
            }
            return emp;
          });;
          this.employeeFetching = false;
          return response.data;
        }),
      );
  }

  isEmployeeAssigned(item: any): boolean {
    if (this.createRouteFormControls?.assigned_to.value?.length) {
      const selectedUser: any = this.createRouteFormControls?.assigned_to.value?.find(value => item?.user_uid === value?.user_uid);
      return selectedUser ? true : false;
    }
    return false;
  }

  getEmployeeTeam(user: any): any {
    const selectedTeam: any = user.teams[0]?.team_name;
    return selectedTeam;
  }

  userSelectionChanged(event: any, item: any): void {
    event.stopPropagation();
    if (!event?.target?.checked && this.createRouteFormControls?.assigned_to.value?.find(value => item?.user_uid === value?.user_uid)) {
      this.unassignEmployee(item);
    }
  }

  unassignEmployee(item: any): void {
    if (this.createRouteFormControls?.assigned_to.value?.length) {
      const selectedUsers: any[] = this.createRouteFormControls?.assigned_to.value?.filter(value => item?.user_uid !== value?.user_uid);
      this.createRouteFormControls?.assigned_to.setValue(selectedUsers);
      this.createRouteFormControls?.assigned_to.markAsDirty();
      if(this.options.state === 'edit'){
        this.createRouteForm.markAsTouched();
      }
    }
  }

  routeTimeString(dateString: any): string {
    const duration = this.createRouteFormControls?.duration?.value;
    const startDate = moment.tz(moment(dateString).format('YYYY-MM-DD HH:mm:ss'),this.timezone);
    const endDate = startDate?.clone().add(duration, 'hours');

    let endDateFormatted = '';
    if (endDate.date() !== startDate.date()) {
      endDateFormatted = endDate.format(this.utilityService?.dateFormat);
    }
    const formattedString = `${startDate.format(this.utilityService?.dateFormat)} ${startDate.format(this.utilityService?.timeFormat)} to ${endDateFormatted} ${endDate.format(this.utilityService?.timeFormat)}`;
    return formattedString;
  }


  openLocation(type: string): void {
    const formControl = type === 'start' ? 'start_location' : 'end_location';
    const previewAddress: MatDialogRef<PreviewAddressFormComponent> = this.zuperDialogService.openCustom(PreviewAddressFormComponent,
      {
        extraClass: 'create-route-preview-address-form',
        data: {
          header: {
            titleDisplayKey: type === 'start' ? 'text.start_location' : 'text.end_location',
            titleDisplayName: type === 'start' ? 'Start Location' : 'End Location'
          },
          formGroupName: formControl,
          formGroup: this.createRouteForm,
          value: this.createRouteFormControls[formControl].value,
          module: 'createRoute',
        }
      });
    previewAddress.disableClose = true;
    previewAddress.afterClosed().subscribe((result: any) => {
      if (result) {
        this.createRouteForm?.get(formControl)?.setValue(result);
        result['country'] = result?.country?.label || result?.country || ''; 
        if (type === 'start') {
          this.createRouteForm?.get('start_location_value')?.setValue(this.createRouteService.getAddressText(result));
          this.createRouteForm?.get('start_location_value').markAsDirty();
          const inputElement: HTMLInputElement = this.start_location.nativeElement;
          inputElement.focus();
          inputElement.setSelectionRange(0, 0);
        } else {
          this.createRouteForm?.get('end_location_value')?.setValue(this.createRouteService.getAddressText(result));
          this.createRouteForm?.get('end_location_value').markAsDirty();
          const inputElement: HTMLInputElement = this.end_location.nativeElement;
          inputElement.focus();
          inputElement.setSelectionRange(0, 0);
        }
      }
    });
  }

  scrollToFirstInvalidControl() {
    if (this.createRouteFormEleRef && this.createRouteFormEleRef.nativeElement) {
      const firstInvalidControl = this.createRouteFormEleRef.nativeElement.querySelector('.ng-invalid');
      if (firstInvalidControl) {
        firstInvalidControl.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  submitCreateRouteForm(): void {
    this.createRouteForm.markAllAsTouched();
    this.setupErrorHandling(true);
    if (this.createRouteForm.invalid) {
      this.scrollToFirstInvalidControl();
      return;
    }
    if (!this.createRouteForm.dirty && this.options?.state === 'edit' && !this.isJobChanged()) {
      this.closeDrawer();
      return;
    }

    if (this.createRouteForm.valid) {
      let payload = {};
      const submit = {
        action: (this.options.state === 'edit') ? 'putData' : 'postData',
        url: (this.options.state === 'edit') ? this._mapService.mapsAPi.getRoutes + `/${this.data?.route_uid ? this.data?.route_uid : this.data?.recurring_route_uid}` : this._mapService.mapsAPi.getRoutes,
        load: (this.options?.state === 'edit') ? this.utilityService.getLocaleValue('content.route_being_updated') : this.utilityService.getLocaleValue('loader.create.route')
      };
      if (this.options?.state === 'clone') {
        submit['url'] = this._mapService.mapsAPi.getRoutes + `/${this.data?.route_uid}/clone`;
      }
      const formValue = this.createRouteForm.value;
      payload['duration'] = +formValue.duration;
      payload['color'] =  formValue.color?.hex ? '#' +formValue.color?.hex : formValue.color;
      payload['route_timezone'] =  this.timezone;
      payload['start_location'] = {
        ...formValue.start_location,
        'name': formValue.start_location.city || '',
        'street': formValue.start_location.street || '',
        'country': formValue?.start_location?.country?.label || formValue?.start_location?.country || '',
        'geo_cords': [formValue.start_location.latitude, formValue.start_location.longitude],
        'zip_code': formValue.start_location.zipcode || formValue.start_location.zip_code || ''
      };
      if (formValue.end_location.latitude && formValue.end_location.longitude) {
        payload['end_location'] = {
          ...formValue.end_location,
          'name': formValue.end_location.city || '',
          'street': formValue.end_location.street || '',
          'country': formValue?.end_location?.country?.label || formValue?.end_location?.country || '',
          'geo_cords': [formValue.end_location.latitude, formValue.end_location.longitude],
          'zip_code': formValue.end_location.zipcode || formValue.end_location.zip_code || ''
        };
      }
      payload['route_type'] = formValue.route_type;
      payload['transport_mode'] = formValue.transport_mode;
      payload['route_name'] = formValue.recurring_route_name;
      payload['route_description'] = formValue.route_description;
      if (formValue.recurrence === '' || (this.options.state !== 'new' && !this.isMasterRouteEdit)) {
        payload['departure'] = moment.tz(moment(formValue.date_time).format('YYYY-MM-DD HH:mm:ss'), this.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      } else {
        payload['route_is_created_through_custom'] = formValue?.recurrence === 'CUSTOM';
        submit['url'] = this.createRouteService.routesAPi.recurringRoute;
        if (this.options?.state === 'edit' && this.isMasterRouteEdit === true) {
          submit['url'] = this.createRouteService.routesAPi.recurringRoute + `/${this.data?.recurring_route_uid}`;
          payload['route_end'] = moment(this.rRuleOptions?.options?.until).add(formValue.duration,'hours').utc().format('YYYY-MM-DD HH:mm:ss');
        }
        if (this.options?.state === 'edit' && this.isMasterRouteEdit === false) {
          submit['url'] =  this._mapService.mapsAPi.getRoutes + `/${this.data?.route_uid}`;
        }

        let type = '';
        switch (formValue.recurrence) {
          case 'DAILY':
            type = 'DAYS';
            break;
          case 'WEEKLY':
            type = 'WEEKS';
            break;
          case 'MONTHLY':
            type = 'MONTHS';
            break;
          case 'MONTHLY-ORDINAL-WEEK':
            type = 'MONTHS';
            break;
          case 'YEARLY':
            type = 'YEARS';
            break;
          case 'CUSTOM':
            type = formValue.repeat.type;
            break;
        }
        payload['recurring_route_name'] = formValue.recurring_route_name;
        payload['route_duration'] = +formValue.duration;
        payload['recurring_route_description'] = formValue.route_description;
        delete this.rRuleOptions?.origOptions?.tzid;
        const origOptions = {...this.rRuleOptions.origOptions,tzid:'UTC'};
        const  utcRRule = new RRule(origOptions);
        const dates = utcRRule?.all();
        const recurrence_dates = [];
        dates.forEach((dateObj) => {
          const utcDayjs = dayjs(dateObj).tz(this.timezone).utc();
          const parsedDate = utcDayjs.format('YYYY-MM-DD HH:mm:ss');
          recurrence_dates.push({ departure: parsedDate });
        });
        payload['rrule'] = {
          'rule_string': utcRRule?.toString().replace(':', '=').replace('\n', ';').replace('RRULE:',''),
          'duration': {
            'value': this.rRuleOptions.options.interval,
            'type': type
          }
        };
        payload['recurrence_dates'] = recurrence_dates;
        if (this.jobs.length > 0 && this.isMasterRouteEdit === false) {
          payload['recurring_jobs'] = this.jobs.map((job_data: any) => ({ recurring_job_uid: job_data.job_uid }));
        }else if(this.jobs.length > 0 && this.isMasterRouteEdit){
          payload['recurring_jobs'] = this.jobs.map((job_data: any) => ({ recurring_job_uid: job_data.recurring_job_uid }));
        }
        if(formValue?.assigned_to?.length > 0){
          payload['assigned_to'] = formValue.assigned_to.map((assigned)=>{
            const data = {};
            if(assigned?.team){
              data['team_uid'] = assigned?.team?.team_uid;
            }else{
              data['team_uid'] = assigned?.teams[0]?.team_uid;
            }
            if(assigned?.user){
              data['user_uid'] = assigned?.user?.user_uid;
            }else{
              data['user_uid'] = assigned?.user_uid;
            }
            return data;
          });
        }
        payload = { recurring_route: payload };
      }

      if (this.jobs?.length > 0 && ['edit','new'].includes(this.options?.state)&& (formValue.recurrence === '' || !this.isMasterRouteEdit)) {
        payload['jobs'] = this.jobs.map((job: any) => ({'job': job?.job_uid}));
        payload['jobs'] = [];
        this.jobs.forEach((job: any) => {
          const data = {
              'job_uid': job?.job_uid
          };
          if(job?.customer_address?.geo_cordinates?.length > 0) {
            data['geo_cords'] = job.customer_address.geo_cordinates;
            payload['jobs'].push(data);
          }else if(job?.geo_cords?.lat && job?.geo_cords?.lng){
            data['geo_cords'] = [job?.geo_cords?.lat, job?.geo_cords?.lng];
            payload['jobs'].push(data);
          }
        });
      }

      if(formValue?.assigned_to?.length > 0 && formValue.recurrence === ''){
        payload['users'] = formValue.assigned_to.map((assigned)=>{
          const data = {...assigned};
          if(assigned?.team){
            data['team_uid'] = assigned?.team?.team_uid;
          }else{
            data['team_uid'] = assigned?.teams[0]?.team_uid;
          }
          if(assigned?.user){
            data['user_uid'] = assigned?.user?.user_uid;
          }else{
            data['user_uid'] = assigned?.user_uid;
          }
          return data;
        });
      }

      if(!this.createRouteFormControls?.date_time?.touched && this.options?.state === 'edit'){
        delete payload['date_time'];
        if(this.isMasterRouteEdit){
        // delete payload['recurring_route']['route_end'];
        }
      }

      // ** Master edit
      if(this.options?.state === 'edit' && this.isMasterRouteEdit === true && payload['recurring_route']['recurring_jobs']){
        payload['recurring_route']['recurring_jobs'] = payload['recurring_route']['recurring_jobs']?.map((recurring_jobs: any, recurring_jobs_index: any)=>({
          ...recurring_jobs,
          sequence: recurring_jobs_index + 1
        }));
      }

      const loader = this._toast.loading(submit['load']);
      this._dataCollectorService[submit['action']](submit['url'], payload)
        .subscribe(async (res: any) => {
          if(this.options?.state === 'edit'){
            const userData = formValue.assigned_to.map((assigned)=>{
              const data = assigned;
              if(!assigned?.user){
                data['user'] = assigned;
              }
              if(!assigned?.team && assigned?.teams?.length){
                data['team'] = assigned?.teams[0];
              }
              return data;
            });
            await this.updateAssigneeInRoute(userData ?? []);
          }
          if(formValue.recurrence !== ''){
            let recurringRouteUid: any;
            const urlParams = new URLSearchParams(window.location.search);
            if(res?.recurring_route_uid  || res?.job_route_uid){
              recurringRouteUid = res?.recurring_route_uid  ?? res?.job_route_uid;
            }
            recurringRouteUid = urlParams.get('recurrence-route-uid') || this.data?.recurring_route_uid || recurringRouteUid;
           setTimeout(() => {
            this.actionComplete.emit({
              state: this.options?.state,
              completed: true,
              data: { recurring_route_uid: recurringRouteUid},
              isMasterRouteEdit: this.isMasterRouteEdit
            });
           }, 100);
            if(this.options?.state === 'new'){
              this.openCreatedPopup(res);
            }else{
            this._toast.success(res?.message);
            }
          }else{
          this._toast.success(res?.message);
          this.actionComplete.emit({
            state: this.options?.state,
            completed: true,
            uid: res?.job_route_uid,
            data: payload
          });
          }
          this.closeDrawer();
          loader.close();
        },(err)=>{
          loader.close();
        });
    } else {
      this.createRouteForm.markAllAsTouched();
    }
  }

  isJobChanged(): boolean {
    if (this.isMasterRouteEdit) {
      if (this.jobs?.length !== this.data?.recurring_jobs?.length) {
        return true;
      }
      for (let i = 0; i < this.jobs?.length; i++) {
        if (this.jobs[i].recurring_job_uid !== this.data.recurring_jobs[i].recurring_job_uid) {
          return true;
        }
      }
      return false;
    }
    else {
      if (this.jobs?.length !== this.data?.jobs?.length) {
        return true;
      }
      for (let i = 0; i < this.jobs?.length; i++) {
        if (this.jobs[i].job_uid !== (this.data.jobs[i]?.job_uid || this.data.jobs[i]?.job?.job_uid)) {
          return true;
        }
      }
      return false;
    }
  }

  async updateAssigneeInRoute(newAssignedUsers: any): Promise<boolean>{
    return new Promise((resolve) => {
      const oldAssignedUsers = this.data?.assigned_to;
      if(this.isMasterRouteEdit){
        this.recurringRouteService.updateRecurringRouteUserAssignments(this.data?.recurring_route_uid, oldAssignedUsers, newAssignedUsers, false,(completedStatus: any[]) => {
          resolve(!!completedStatus?.length);
        });
      }else{
        this.recurringRouteService.updateRouteAssignments(this.data?.route_uid, oldAssignedUsers, newAssignedUsers,false, (completedStatus: any[]) => {
          resolve(!!completedStatus?.length);
        });
      }
    });

  }

  onPresetColorSelect(event: any): void {
    const selectedColor = event.target.value;
    this.createRouteForm.patchValue({ color: selectedColor });
    this.selectedRouteColor = selectedColor;
    this.selectedRouteTextColor = this.utilityService.getTextColorBasedOnBg(selectedColor);
  }

  resetStartLocation(): void{
    this.createRouteForm?.get('start_location_value')?.setValue('');
    this.createRouteForm?.get('start_location')?.reset();
  }

  resetEndLocation(): void{
    this.createRouteForm?.get('end_location_value')?.setValue('');
    this.createRouteForm?.get('end_location')?.reset();
  }

  buildCreateRouteForm(): void {
    this.createRouteForm = this.form_builder.group({
      recurring_route_name: ['', [Validators.required]],
      route_description: [''],
      assigned_to: [''],
      RRule: [''],
      departure_dates: [''],
      start_location: this.getAddressFormGroup('start'),
      start_location_value: [''],
      end_location: this.getAddressFormGroup('end'),
      end_location_value: [''],
      duration: [8, [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/), Validators.min(1), Validators.max(24)]],
      date_time: [this.today, [Validators.required]],
      recurrence: ['',],
      color: ['#e67e22'],
      transport_mode: ['CAR'],
      route_type: ['FASTEST'],
      repeat: this.form_builder.group({
        count: [1, [Validators.required,Validators.pattern(/^\d+(\.\d+)?$/),Validators.min(1), Validators.max(100)]],
        type: ['WEEKS', []],
        repeat_on: [this.days, []],
      }),
      recurrence_ends: this.form_builder.group({
        type: ['recurrence_ends_on'],
        ends_on: [this.today, this.routeEndsOnValidator],
        ends_after: [1, [Validators.pattern(/^\d+(\.\d+)?$/),Validators.min(1), Validators.max(1000)]],
      })
    });
  }

  routeEndsOnValidator(control: AbstractControl): ValidationErrors | null {
    if (control?.value && control?.parent?.controls?.['ends_after']?.invalid) {
      return { 'invalid-date': true };
    }
    return null;
  }

  get createRouteFormControls(): { [key: string]: any } {
    return this.createRouteForm?.controls;
  }


  getDate(date: Date): string {
    return moment(date).format('Do');
  }

  getDay(date: Date): string {
    return moment(date).format('dddd');
  }

  getMonthDay(date: Date): string {
    return moment(date).format('MMMM Do');
  }

  getDayWithWeekCount(date: Date): string {
    const targetDate = moment(date);
    const dayOfWeek = targetDate.format('ddd');
    const dayOfMonth = targetDate.date();
    const firstTargetDayOfMonth = moment(date).startOf('month').day(targetDate.day());

    const weekDifference = Math.floor((dayOfMonth - firstTargetDayOfMonth.date()) / 7);
    const ordinalArray = ['1st', '2nd', '3rd', '4th', '5th'];
    let ordinalIndex = Math.min(weekDifference, ordinalArray.length - 1);
    ordinalIndex = ordinalIndex < 1 ? 0 : ordinalIndex;
    return `${ordinalArray[ordinalIndex]} ${dayOfWeek}`;
  }

  getRRuleAsString(ruleString: any): string {
    if (ruleString) {
      const rule = RRule?.fromString(ruleString);
      return rule?.toText() ?? '';
    }
    return '';
  }

  setRepeatDay(): void {
    const date = this.createRouteForm?.get('date_time').value || this.today;
    const selectedDay = moment(date).day()-1;
    this.days.map((item) => {
      if (this.options.state === 'new'){
        item.week.map((day: { label: string; value: boolean }) => {
        if (item.week[selectedDay < 0 ? 0 : selectedDay ].label === day.label) {
          day.value = true;
        } else {
          day.value = false;
        }
      });
    }
    });
  }

  constructRrule(forceUpdate: boolean = false): void {
    if (!forceUpdate && (this.createRouteFormControls?.recurrence.value === '' || this.recurringRouteFormErrorMessages['date_time']
      || this.recurringRouteFormErrorMessages['ends_after']
      || this.recurringRouteFormErrorMessages['duration']
      || this.recurringRouteFormErrorMessages['count']
    )) {
      return;
    }
    const until = this.createRouteFormControls?.recurrence_ends?.get('type').value === 'recurrence_ends_on' ? 'date' : 'count';
    const start_date = moment(this.createRouteFormControls?.date_time.value).toISOString();
    const end_value = this.createRouteFormControls?.recurrence_ends?.get('type').value === 'recurrence_ends_on' ? this.createRouteFormControls?.recurrence_ends?.get('ends_on').value :
      this.createRouteFormControls?.recurrence_ends?.get('ends_after').value;
    const recurrence_value = this.createRouteForm?.get('recurrence').value;
    const customValue = {
      count: this.createRouteFormControls?.repeat?.get('count').value,
      type: this.createRouteFormControls?.repeat?.get('type').value,
      days: this.days
    };
    const rRulerOptions = this.createRouteService.generateRecurrenceRule(recurrence_value, start_date, end_value, until, customValue);
    this.rRuleOptions = new RRule(rRulerOptions);
    const dates = [];
    this.rRuleOptions?.all()?.forEach((dateString) => {
      const parsedDate = moment(dateString).utc().format('YYYY-MM-DD HH:mm:ss');
      dates.push(parsedDate);
    });

    this.setRRuleText(this.rRuleOptions);

    this.createRouteFormControls?.RRule.setValue(this.rRuleOptions);
    this.createRouteFormControls?.departure_dates.setValue(dates);
    this.totalRouteInstance = this.rRuleOptions.count();
    this.departureDateTimeDuration = this.routeTimeString(this.createRouteForm?.get('date_time')?.value);
    const endsAfterControl = this.createRouteFormControls?.recurrence_ends?.get('ends_after');
    const endsOnControl = this.createRouteFormControls?.recurrence_ends?.get('ends_on');
    endsAfterControl?.setValue(Number(this.totalRouteInstance), { emitEvent: false });
    endsAfterControl?.markAsTouched();
    this.updateErrorMessage('ends_after', endsAfterControl);
    endsAfterControl?.updateValueAndValidity({ emitEvent: false });
    endsOnControl?.setValue(moment(rRulerOptions.until), { emitEvent: false });
    endsOnControl?.markAsTouched();
  }

  setRRuleText(rRulerOptions: any): void{
    this.rRuleText = this.utilityService.getRruleText(rRulerOptions.toString(), this.timezone);
  }


  setRecurrenceRepeatDay(clicked_day: any, week_index: any): void {
    const selected_days = this.days[week_index].week.filter(item => item.value);
    clicked_day.value = clicked_day.value === true && selected_days.length === 1 &&
      this.createRouteFormControls?.repeat?.get('type').value !== 'MONTHS'
      ? clicked_day.value : !clicked_day.value;
    this.constructRrule(true);
  }

  setupErrorHandling(checkErrors: boolean = false): void {
    this.cancelErrorHandling$.next();
    const controls = {
      'ends_after': this.createRouteFormControls?.recurrence_ends?.controls?.ends_after,
      'date_time': this.createRouteFormControls?.date_time,
      'duration': this.createRouteFormControls?.duration,
      'count': this.createRouteFormControls?.repeat?.controls?.count,
      'recurring_route_name': this.createRouteFormControls?.recurring_route_name,
      'route_description': this.createRouteFormControls?.route_description,
    };
    Object.keys(controls).forEach((controlName) => {
      const control = controls[controlName];
      if (control) {
        control.valueChanges.pipe(takeUntil(this.cancelErrorHandling$)).subscribe(() => {
          this.updateErrorMessage(controlName, control);
        });

        control.statusChanges.pipe(takeUntil(this.cancelErrorHandling$)).subscribe(() => {
          this.updateErrorMessage(controlName, control);
        });
        if (checkErrors) {
          this.updateErrorMessage(controlName, control);
        }
      }
    });
  }

  updateErrorMessage(controlName: string, control: AbstractControl): void {
    this.recurringRouteFormErrorMessages[controlName] = this.hasError(controlName, control);
  }

  hasError(controlName: string, control: AbstractControl): string {
    if (control?.touched || control?.dirty) {
      if (control?.errors?.max || control?.errors?.min) {
        if (controlName === 'count') {
          return 'route.count_hundred.error';
        }
        if (controlName === 'duration' && control?.errors?.max) {
          return 'dispatchBoard.error.route_max_duration';
        }
        if (controlName === 'duration' && control?.errors?.min) {
          return 'dispatchBoard.error.route_min_duration';
        }
        if (controlName === 'ends_after' && control?.errors?.min && this.options?.state !== 'new') {
          return 'route.ends_after.error';
        }
        if (this.options?.state === 'new' && controlName === 'ends_after' && (control?.errors?.min || control?.errors?.max)) {
          return 'route.count_thousand.error';
        }
      } else if (control?.errors?.pattern) {
        return 'field.pattern.number.error.message';
      } else if (control?.errors?.required) {
        return 'text.field_is_required';
      }
      else if(controlName === 'date_time' && control?.errors?.matDatetimePickerMin){
        return 'request.date.past.error.message';
      }
    }
    return '';
  }

  setDate(picker): void {
    const newDate = moment.tz(moment(this.createRouteForm?.get('date_time').value).format('YYYY-MM-DD HH:mm:ss'),this.timezone);
    picker.select(newDate);
  }

  openCreatedPopup(response: any): void {
    const recurringRouteUid: string = response?.recurring_route_uid;
    const popupButtons = {
      primaryBtn: {
        displayName: 'text.add_job_to.route',
        displayKey: 'ADD_JOB_TO_ROUTE',
        icon:'ti ti-plus',
        showIf: true
      },
      secondaryBtn: {
        displayName: 'text.go_to.route_detail',
        displayKey: 'VIEW_ROUTE_DETAILS',
        showIf: true
      }
    };
    const dialogData: PopupContent = {
      title: this.options.state === 'new' ? 'text.route_created' : 'text.route_edited',
      description: `${this.createRouteFormControls?.recurring_route_name.value} ${this.translateService.instant(
        this.options.state === 'new' ? 'text.project.created_popup.description' :
        'text.project.edited_popup.description')}`,
      buttons: popupButtons
    };
    const popupDialog: any = this.zuperDialogService.openCustom(CreatedPopupComponent, {
      disableClose: true,
      dismissible: false,
      extraClass: 'route-created-popup',
      hasBackdrop: true,
      data: dialogData
    });
    popupDialog.afterClosed().subscribe((result: any) => {
      this.closeDrawer();
      if (result?.emitKey === 'VIEW_ROUTE_DETAILS') {
        this.actionComplete.emit({
          state: this.options?.state,
          completed: true,
          action:'VIEW_RECURRENCE_ROUTE_DETAILS',
          data: {recurring_route_uid:recurringRouteUid},
        });
      }
      else if (result?.emitKey === 'ADD_JOB_TO_ROUTE') {
        this.actionComplete.emit({
          state: this.options?.state,
          completed: true,
          action:'ADD_JOB_TO_RECURRENCE_ROUTE',
          data: {recurring_route_uid:recurringRouteUid},
        });
      }
    });
  }

  openJobDeleteWarningPopup(index: any): void {
    const job = this.jobs[index];
    const dialogTitle = this.utilityService.getLocaleValue('alert.remove_job_from_route', 'Remove Job from Route');
    const dialogMessage = `${this.utilityService.getLocaleValue('alert.remove_job_from_route_message', 'Are you sure to remove the job')} 
    <span class="text-gray-900 font-medium"> ${job?.job_title} </span>
    </span> from <span class="text-gray-900 font-medium">'${this.createRouteFormControls?.recurring_route_name?.value}'</span> ?`;

    const popupDialog = this.zuperDialogService.open({
      title: dialogTitle,
      type: 'error',
      message: dialogMessage,
      actions: {
        confirm: {
          show: true,
          label: 'Yes, Continue',
          color: 'primary',
          confirmDisplayKey: 'yes.continue.text',
        },
        cancel: {
          show: true,
          label: 'Cancel',
          cancelDisplayKey: 'cancel.text'
        }
      },
      dismissible: false,
      extraClass: 'route-job-remove-dialog'
    });
    popupDialog.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.deleteJob(index);
      }
    });
  }

  deleteJob(index: any): void {
    const job = this.jobs[index];
    let url = '';
    let payload = {
    };
    if(this.isMasterRouteEdit){
    url = this._mapService.mapsAPi.getRoutes + `/recurring/${this.data?.route_uid ? this.data?.route_uid : this.data?.recurring_route_uid}/job/${job.recurring_job_uid}`;
    }else{
    url = this._mapService.mapsAPi.getRoutes + `/${this.data?.route_uid ? this.data?.route_uid : this.data?.recurring_route_uid}/job`;
      payload = {
        jobs:[{job_uid:job?.job_uid}],
        unassign_users: false
      };
    }
    this._dataCollectorService['deleteDataPayload'](url, payload)
      .subscribe((res: any) => {
        this._toast.success(res?.message);
        this.jobs.splice(index, 1);
        this.jobs = [...this.jobs];
        this.emitChangesInMap();
        this.calculateRouteDistances();
        if(this.options.state === 'edit'){
          this.createRouteForm.markAsTouched();
        }
      }, (err) => {
      });
  }

  drop(event: CdkDragDrop<any>): void {
    moveItemInArray(this.jobs, event.previousIndex, event.currentIndex);
    this.jobs = [...this.jobs];
    this.calculateRouteDistances();
    this.emitChangesInMap();
    if(this.options?.state === 'edit'){
      this.createRouteForm.markAsTouched();
    }
  }

  formatDepartureTime(): string {
    const startDate = moment(this.createRouteFormControls?.date_time?.value);
    return `${startDate.format(this.utilityService?.dateFormat)} ${startDate.format(this.utilityService?.timeFormat)}`;
  }

  removeJobDetails(index: number): void {

    if(this.options?.state === 'edit' && !this.jobs[index].isNewJobAdded){
      this.openJobDeleteWarningPopup(index);
    }else{
      this.jobs.splice(index, 1);
      this.jobs = [...this.jobs];
      this.emitChangesInMap();
      this.calculateRouteDistances();
    }
  }

  calculateRouteDistances(): void {
    const modeOfTransportRef = {'CAR': 'car', 'TRUCK': 'car', 'BIKE': 'bike', 'PEDESTRIAN': 'foot' };
    const payload = {
      'user_uid': 'detailedRouteCreation',
      'jobs': [],
      'vehicle':modeOfTransportRef[this.createRouteFormControls?.transport_mode?.value],
    };
    payload['jobs'] = this.jobs?.map((job_details: any) => ({
      'job_uid': job_details.job_uid,
      'lat': job_details.customer_address.geo_cordinates[0],
      'lng': job_details.customer_address.geo_cordinates[1]
    }));
    if (this.enableCalculateDistanceApi && this.utilityService?.companyPolicy?.dispatch_board?.distance_time &&
      (payload['jobs'].length > 1 || (this.createRouteForm.controls.end_location_value.value && this.createRouteForm.controls.start_location_value.value)
    || (payload['jobs'].length > 0 && (this.createRouteForm.controls.end_location_value.value || this.createRouteForm.controls.start_location_value.value))
    )
    ) {
      if (this.createRouteFormControls?.start_location?.controls?.latitude.value && this.createRouteFormControls?.start_location?.controls?.longitude.value) {
        payload['jobs'].unshift({
          'job_uid': 'start_location',
          'lat': this.createRouteFormControls?.start_location?.controls?.latitude.value,
          'lng': this.createRouteFormControls?.start_location?.controls?.longitude.value
        });
      }
      if (this.createRouteFormControls?.end_location?.controls?.latitude.value && this.createRouteFormControls?.end_location?.controls?.longitude.value) {
        payload['jobs'].push({
          'job_uid': 'end_location',
          'lat': this.createRouteFormControls?.end_location?.controls?.latitude.value,
          'lng': this.createRouteFormControls?.end_location?.controls?.longitude.value
        });
      }
      this.isGettingDistanceData = true;
      const routes_payload = {routes:[payload]};
      this.createRouteService.getDistanceBetweenJobs(routes_payload).subscribe((distance_response: any)=>{
        this.isGettingDistanceData = false;
        if(distance_response.data.length > 0 ){
          this.distanceCalculated = {...distance_response.data[0]};
        }else{
          this.distanceCalculated = {
            leg_details:[],
            distance:0,
            time:0
          };
        }
       this.totalJobDuration =  this.calculateJobDuration();
      },(err)=>{});
    } else {
      this.distanceCalculated = {
        leg_details:[],
            distance:0,
            time:0
      };
      this.totalJobDuration =  this.calculateJobDuration();
    }
  }

  calculateJobDuration(): string {
    let totalJobsMileSec = 0;
    this.jobs.forEach((job) => {
      if(job?.scheduled_duration){
      totalJobsMileSec += job?.scheduled_duration ?? 0;
      }else if(job?.job_duration){
      totalJobsMileSec += job?.job_duration ?? 0;
      }
    });
    this.totalJobsDurationMileSec = totalJobsMileSec;
    const totalDuration = (this.distanceCalculated.time/60000)+totalJobsMileSec;
    this.totalRouteDuration = this.utilityService.convertMinstoHours(Math.abs(totalDuration));
    return (this.utilityService.convertMinstoHours(Math.abs(totalJobsMileSec)));
  }

  checkJobConflict(): void {
    const formValue = this.createRouteForm.value;
    if(this.jobs.length > 0 && formValue?.assigned_to?.length > 0 && formValue.recurrence !== ''){
      const payload = {
        'conflict_count_only': false,
        'timezone':this.timezone,
        'move_all_recurring_job_instances': false,
        'route_conflict': {
          'conflict_check_types': [
            'USER',
            'SKILL',
            'DATE'
          ],
          'operation_type': 'job_assignment_before_route_creation',
          'data': {
              'recurring_job_uids': this.jobs.map(job=>( this.options.state === 'new' ? job?.job_uid : job?.recurring_job_uid)),
              'departure_dates':[...formValue.departure_dates],
            'duration':formValue.duration,
            'repeat_frequency':formValue.repeat.type,
            'repeat_every':formValue.repeat.count
          }
      }
      };

      if(formValue?.assigned_to?.length > 0){
        payload['route_conflict']['data']['assigned_to'] = formValue.assigned_to.map((assigned)=>{
          const data = {};
          if(assigned?.team){
            data['team_uid'] = assigned?.team?.team_uid;
          }else{
            data['team_uid'] = assigned?.teams[0]?.team_uid;
          }
          if(assigned?.user){
            data['user_uid'] = assigned?.user?.user_uid;
          }else{
            data['user_uid'] = assigned?.user_uid;
          }
          return data;
        });
      }
      this.createRouteService.getRecurringRouteConflicts({...payload}).subscribe((conflict_response: any)=>{
        if(conflict_response?.data){
          const response = [...conflict_response?.data];
          const jobData = this.jobs.map((job) => {
            job.conflict_count = 0;
            job.conflict = response.map((conflict) => {
              const newConflict = {...conflict};
              newConflict.conflictsData = newConflict.conflicts.filter(item => item?.master_job_uid === job?.recurring_job_uid);
              job.conflict_count += newConflict.conflictsData?.length;
              return newConflict;
            });
            return job;
          });
          this.jobs = [...jobData];
        }
      });
    }
  }

  changeDetailedView(): void{
    this.showDetailedRouteCreationForm = !this.showDetailedRouteCreationForm;
    if(this.createRouteForm?.get('start_location_value').value || this.createRouteForm?.get('end_location_value').value && this.showDetailedRouteCreationForm === true){
    this.emitChangesInMap();
    }
    this.jobs = [];
  }

  emitChangesInMap(): void{
    if(this.openPicker === true){
      const changeData = {data:{...this.createRouteForm.value},jobs:this.jobs,panJob:false};
      this.createRouteService.routeMapData.next(changeData);
    }
  }

  showJobDetails(index: number): void {
    if(this.openPicker === true){
      this.createRouteService.routeMapData.next({data:this.jobs[index],panJob:true});
    }
  }

  get transportModeClass(): string {
    const mode = this.createRouteForm?.get('transport_mode')?.value;
    switch (mode) {
      case 'CAR':
        return 'ti-car';
      case 'TRUCK':
        return 'ti-truck';
      case 'PEDESTRIAN':
        return 'ti-walk';
      default:
        return '';
    }
  }

  setDefaultEndDateValues(): void {

    if(this.options.state !== 'new' || this.createRouteFormControls?.recurrence_ends?.get('type')?.dirty){
      return;
    }
    const recurrenceValue: string = this.createRouteFormControls?.recurrence?.value;
    const routeStartDate: AbstractControl = this.createRouteFormControls?.date_time;
    const routeEndDate: AbstractControl = this.createRouteFormControls?.recurrence_ends?.get('ends_on');
    const date = moment(routeStartDate.value).startOf('D');

    switch (recurrenceValue) {
      case 'DAILY':
        date.add(7, 'days');
        routeEndDate.setValue(date,{emitEvent: false});
        break;
      case 'WEEKLY':
        date.add(1, 'month');
        routeEndDate.setValue(date,{emitEvent: false});
        break;
      case 'MONTHLY':
        date.add(3, 'month');
        routeEndDate.setValue(date, { emitEvent: false });
        break;
      case 'MONTHLY-ORDINAL-WEEK':
        date.add(3, 'month');
        routeEndDate.setValue(date, { emitEvent: false });
        break;
      case 'YEARLY':
        date.add(2, 'years');
        routeEndDate.setValue(date);
        break;
      case 'CUSTOM':
          const routeRepeatType: AbstractControl = this.createRouteFormControls?.repeat?.get('type');
          date.add(routeRepeatType.value === 'WEEKS' ? 1 : 3, 'month');
          routeEndDate.setValue(date,{emitEvent: false});
        break;
    }
  }

  setRecurrenceEnd(value: string): void{
    if(this.createRouteFormControls?.recurrence_ends?.get('type')?.value !== value){
    this.createRouteFormControls?.recurrence_ends?.get('type')?.setValue(value);
    }
  }

  checkEndsAfterValue(): void{
    const endsAfterControl = this.createRouteFormControls?.recurrence_ends?.get('ends_after');
    if(endsAfterControl.value > 0 ){
      this.constructRrule();
    }
  }

  removeSelectedJobsDialog(previousRecurranceValue): void{
    const jobRemovalConfirmationDialog = this.zuperDialogService.open({
      title: this.utilityService.getLocaleValue('text.change_in_recurrence','Change in Recurrence'),
      type: 'error',
      message: this.utilityService.getLocaleValue('message.change_in_recurrence','Changing the route recurrence will remove all added jobs. Are you sure?'),
      actions: {
        confirm: {
          show: true,
          label: 'Yes, Continue',
          color: 'primary',
          confirmDisplayKey: 'yes.continue.text',
        },
        cancel: {
          show: true,
          label: 'Cancel',
          cancelDisplayKey: 'cancel.text'
        }
      },
      dismissible: false,
      extraClass: 'route-job-remove-dialog'
    });
    jobRemovalConfirmationDialog.afterClosed().subscribe((status: boolean) => {
      if (status) {
        this.jobs = [];
      }
      else {
        this.createRouteForm?.get('recurrence').setValue(previousRecurranceValue, { emitEvent: false });
      }
    });
  }

  initFormBuilder(): void{
    this.buildCreateRouteForm();
    this.employees = this.getEmployees('');
    this.createRouteForm?.get('recurrence')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe((recurrence_value: any) => {
      const previousRecurranceValue = this.createRouteForm.value['recurrence'];
      this.setRepeatDay();
      this.setDefaultEndDateValues();
      this.constructRrule(true);
      if (previousRecurranceValue !== recurrence_value && this.jobs.length > 0 && this.showDetailedRouteCreationForm && this.options?.state === 'new') {
        this.removeSelectedJobsDialog(previousRecurranceValue);
      }
    });
    this.createRouteForm?.get('assigned_to')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe((assigned_to: any) => {
      if(this.isMasterRouteEdit === true || this.options?.state === 'new'){
        this.checkJobConflict();
      }
    });
    this.createRouteForm?.get('transport_mode')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe((transport_mode: any) => {
      this.emitChangesInMap();
      if (this.showDetailedRouteCreationForm === true) {
        this.calculateRouteDistances();
      }
     });
     this.createRouteForm?.get('route_type')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe((route_type: any) => {
      this.emitChangesInMap();
     });
     this.createRouteForm?.get('color')?.valueChanges?.pipe(distinctUntilChanged(),debounceTime(500),takeUntil(this.unsubscribe$))?.subscribe((color: any) => {
      this.selectedRouteColor = color?.hex ? '#' +color?.hex : color;
      this.selectedRouteTextColor = this.utilityService.getTextColorBasedOnBg(this.selectedRouteColor);
      this.emitChangesInMap();
     });
    this.createRouteFormControls?.repeat?.get('count')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe((value: any) => {
      if(value > 0){
        this.constructRrule();
      }
    });
    this.createRouteFormControls?.repeat?.get('type')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe((value: any) => {
      this.setDefaultEndDateValues();
      const daysArray = [];
      const daysObject = this.days[0];
      if(this.options?.state !== 'new'){
        daysObject.week.map((item)=>{item.value = false;});
      }
      if (value === 'MONTHS') {
        for (let i = 0; i < 5; i++) {
            daysArray.push(_.cloneDeep(daysObject));
        }
      }else{
        daysArray.push(daysObject);
      }
      this.days = daysArray;
      this.constructRrule();
    });
    this.createRouteForm?.get('duration')?.valueChanges?.pipe(debounceTime(500),distinctUntilChanged(),takeUntil(this.unsubscribe$))?.subscribe((value: any) => {
      this.constructRrule();
      this.departureDateTimeDuration = this.routeTimeString(this.createRouteForm?.get('date_time')?.value);
    });
    this.createRouteFormControls?.recurrence_ends?.get('type')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe((value: any) => {
      if(value === 'recurrence_ends_on' && this.options?.state !== 'edit'){
          this.createRouteFormControls?.recurrence_ends?.get('ends_after').setValue(1);
          this.createRouteFormControls?.recurrence_ends?.get('ends_after').updateValueAndValidity();
      }
      this.constructRrule(true);
    });
    this.createRouteFormControls?.recurrence_ends?.get('ends_after')?.valueChanges?.pipe(debounceTime(500),distinctUntilChanged(),takeUntil(this.unsubscribe$))?.subscribe((value: any) => {
      if(value > 0 && value < this.minimumRouteInstanceEndValue && this.options?.state === 'edit'){
        const endsAfterControl = this.createRouteFormControls?.recurrence_ends?.get('ends_after');
        const endsOnControl = this.createRouteFormControls?.recurrence_ends?.get('ends_on');
        endsAfterControl.addValidators(Validators.min(this.minimumRouteInstanceEndValue));
        endsAfterControl.updateValueAndValidity({emitEvent:false});
        endsOnControl.updateValueAndValidity({emitEvent:false});
      }
      if(value > 0 ){
        this.constructRrule(true);
      }
    });
    this.createRouteFormControls?.recurrence_ends?.get('ends_on')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe((value: any) => {
      this.constructRrule(true);
    });
    this.createRouteForm?.get('date_time')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe((value) => {
      this.departureDateTime = `${moment.tz(value,this.timezone).format(this.utilityService?.dateFormat)} ${moment.tz(value,this.timezone).format(this.utilityService?.timeFormat)}`;
      this.departureDateTimeDuration = this.routeTimeString(this.createRouteForm?.get('date_time')?.value);
      if (this.createRouteForm?.get('recurrence')?.value !== 'CUSTOM') {
        this.setRepeatDay();
      }
      this.constructRrule();
      this.setDefaultEndDateValues();
    });
    this.createRouteForm?.get('start_location_value')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe(() => {
      if (this.showDetailedRouteCreationForm === true) {
        const formValue = this.createRouteForm.value;
        if (formValue.start_location?.latitude + '', formValue.start_location?.longitude + '') {
          this.startLocationGeoCords = [formValue.start_location.latitude, formValue.start_location.longitude];
        }
        else {
          this.startLocationGeoCords = [];
        }
        this.calculateRouteDistances();
        this.emitChangesInMap();
      }
    });
    this.createRouteForm?.get('end_location_value')?.valueChanges?.pipe(takeUntil(this.unsubscribe$))?.subscribe(() => {
        this.calculateRouteDistances();
        this.emitChangesInMap();
    });
    this.setupErrorHandling();
  }

  ngOnInit(): void {
    moment.tz.setDefault(this.timezone);
    this.companyConfig = this._localStorageService.getLocalStorage('company_configuration_data');
    this.showMeridian = this.utilityService.showMeridian;
  }

}

